module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Session Timeout\" style=\"display: none;\">\r\n    <div class=\"container-fluid\" style=\"font-size:12px; padding-top: 20px;\">\r\n        <div class=\"row\">\r\n              <p>The current session has timed out. You will be redirected to the login page.</p>\r\n        </div>           \r\n    </div>    \r\n</div>")
  }
  return __output;

}